require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/es7.symbol.observable.js
 ** module id = 1547
 ** module chunks = 0
 **/